import { ConfigurableWingViewModelInterface, WingViewModelInterface } from "@nts/std/interfaces";


export function isConfigurableWingViewModel(
  wingViewModel: WingViewModelInterface
): wingViewModel is ConfigurableWingViewModelInterface {
  const candidate = wingViewModel as Partial<ConfigurableWingViewModelInterface> | null;

  return !!candidate
    && typeof candidate.requestOpen === 'function'
    && typeof candidate.requestClose === 'function'
    && typeof candidate.requestToggle === 'function'
    && typeof candidate.isModal === 'function'
    && typeof candidate.modalOptions === 'function'
    && typeof (candidate as { stateChanged$?: { subscribe?: unknown; }; }).stateChanged$?.subscribe === 'function';
}
